export const SIZES = {
  changeMapButtonWidth: 298,
};
